import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormControl,Validators, FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AutenticacaoService } from 'src/app/services/autenticacao.service';


@Component({
    selector: 'app-support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.css'],
    imports: [ReactiveFormsModule, FormsModule]
})
export class SupportComponent implements OnInit {

  urlChat: string = null;
  credenciais: any = null;
  form: FormGroup = null;
  serchText:string = "";

  constructor(private http: HttpClient, private autenticacao: AutenticacaoService) {

    this.credenciais = this.autenticacao.getCredenciais();

    this.form =  new FormGroup({
      mensagem: new FormControl(null, [Validators.required]),
      tipo: new FormControl ("",[Validators.required])
    })

  }

  ngOnInit() {
    this.gerarUrlChat();
  }

  gerarUrlChat(){

    let c: any = this.credenciais;
    this.urlChat = `https://www10.directtalk.com.br/chat31/?idd=E40C002316B92007128D&nome=${encodeURI(c.nome)}&cpf=${encodeURI(c.cpf)}&email=${encodeURI(c.email)}&telefone=${encodeURI(c.celular)}`;
  }

  public enviaMensagem(){
    this.http
    .post(`${environment.apiURL}/logado/Atendimento/EnviaEmail`,this.form.value)
    .subscribe(
      (res:any)=>{

      }
    )
  }


  public buscarAssunto(){
    //debugger
    var list = document.querySelector('#accordionFaq').childNodes

    list.forEach(item=>{

        let list = []

        list.push(item.firstChild.firstChild.textContent)

    })

  }
}
